var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20019 1.67573C8.20019 1.2339 8.55837 0.875732 9.00019 0.875732C13.8603 0.875732 17.8002 4.81563 17.8002 9.67573C17.8002 14.5358 13.8603 18.4757 9.00019 18.4757C4.14009 18.4757 0.200195 14.5358 0.200195 9.67573C0.200195 9.2339 0.558367 8.87573 1.0002 8.87573C1.44202 8.87573 1.8002 9.2339 1.8002 9.67573C1.8002 13.6522 5.02375 16.8757 9.00019 16.8757C12.9766 16.8757 16.2002 13.6522 16.2002 9.67573C16.2002 5.69928 12.9766 2.47573 9.00019 2.47573C8.55837 2.47573 8.20019 2.11756 8.20019 1.67573Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.0002,
    y1: 17.6755,
    x2: 17.0002,
    y2: 17.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556BFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputLoader);
export default __webpack_public_path__ + "static/media/InputLoader.27c3a704.svg";
export { ForwardRef as ReactComponent };